import { createAsyncThunk } from "@reduxjs/toolkit";
import { APP_PATH } from "../../api/backendPath";
import { toast } from '../../components/toast';
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

import i18n from "../../i18n";
// Fetches nurse orders for the Order Management page.
// `tab` maps server-side to one or more order statuses.
export const fetchNurseOrdersReducer = createAsyncThunk(
  "orderManagement/fetchNurseOrders",
  async (
    { tab = "Received", search = "", date = "", location = "", page = 1, limit = 10 } = {},
    { rejectWithValue }
  ) => {
    const axiosPrivate = await useAxiosPrivate();
    try {
      const queryParamsObj = { page: String(page), limit: String(limit) };
      if (tab) queryParamsObj.tab = tab;
      if (search) queryParamsObj.search = search;
      if (date) queryParamsObj.date = date;
      if (location) queryParamsObj.location = location;
      const queryParams = new URLSearchParams(queryParamsObj).toString();
      const fullUrl = `${process.env.REACT_APP_API_URL}${APP_PATH.nurseOrders}?${queryParams}`;
      const response = await axiosPrivate.get(fullUrl);

      if (response?.data?.status === true || response?.status === 200) {
        return response.data.data;
      } else {
        const msg = response?.data?.message || i18n.t("toast.failedToFetchOrders");
        toast.error(msg);
        return rejectWithValue(msg);
      }
    } catch (error) {
      console.error("Error fetching nurse orders:", error);
      const errMsg =
        error?.response?.data?.message ||
        i18n.t("toast.errorFetchingOrders");
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  }
);
